import { Flex, Typography, theme } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface Props {
  url: string
  height: string
}

/** The frozen document, shown from a blob URL that has no address of its own. */
const PdfViewer: React.FC<Props> = ({ url, height }) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <object
      data={url}
      type="application/pdf"
      style={{
        width: "100%",
        height,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadius
      }}
      aria-label={t("signing.document.viewerLabel")}
    >
      {/* Mobile browsers routinely refuse to render a PDF inline. */}
      <Flex vertical gap={8} align="center" style={{ padding: token.padding }}>
        <Text type="secondary">{t("signing.document.cannotDisplay")}</Text>
      </Flex>
    </object>
  )
}

export default PdfViewer
